//#region src/bite_service_name.ts
var BiteServiceName = /* @__PURE__ */ function(BiteServiceName) {
	BiteServiceName["BuildAndDeploy"] = "build-and-deploy";
	BiteServiceName["Bureau"] = "bureau";
	BiteServiceName["Clock"] = "clock";
	BiteServiceName["DbCollectionWatcher"] = "db-collection-watcher";
	BiteServiceName["Eclair"] = "eclair";
	BiteServiceName["Flash"] = "flash";
	BiteServiceName["Garcon"] = "garcon";
	BiteServiceName["Maitred"] = "maitred";
	BiteServiceName["McpApp"] = "mcp-app";
	BiteServiceName["JobWorker"] = "job-worker";
	BiteServiceName["QueueConsumerInternal"] = "queue-consumer-internal";
	BiteServiceName["QueueConsumerOperational"] = "queue-consumer-operational";
	BiteServiceName["QueueConsumerOrders"] = "queue-consumer-orders";
	BiteServiceName["QueueConsumerQuicksand"] = "queue-consumer-quicksand";
	BiteServiceName["QueueConsumerQuicksandSmall"] = "queue-consumer-quicksand-small";
	BiteServiceName["QueueConsumerWebhooks"] = "queue-consumer-webhooks";
	BiteServiceName["RecommendationApp"] = "recommendations";
	BiteServiceName["Scripts"] = "scripts";
	BiteServiceName["Vitrine"] = "vitrine";
	BiteServiceName["WebhookReceiver"] = "webhook-receiver";
	return BiteServiceName;
}(BiteServiceName || {});
//#endregion
export { BiteServiceName };

//# sourceMappingURL=bite_service_name.js.map